module.exports = __webpack_public_path__ + "img/waardeoverdracht.88ce366f.png";